export default {
      id: "alert-circle-outline-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#alert-circle-outline-usage",
      toString: function () {
        return this.url;
      }
    }